/**
 * Created by ducnn on 1/3/20.
 */
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory();